import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { toast } from "react-toastify";

const updatePatient = async (data) => {
    const payload = {
        ...data,
    };

    const res = await api.patch(`/Patient`, payload);

    return res.data;
};

export const useUpdatePatient = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updatePatient,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["patient"],
            });

            toast.success("Profile successfully updated");
        },
        onError: () => {
            toast.error("Error updating profile");
        },
    });
};
